import { useMutation } from "react-query"

import { api } from "../services/axios"

export const useAddUserOpti = () => {
  return useMutation(
    async (plugin) => {
      const { data, status } = await api.post("/cadastro/plugin", plugin)
      return { data, status }
    }
  )
}